import { Component, Input } from '@angular/core';

import { BridgeService, BrowserService, DeviceSettingsRepository } from 'webcommon/legacy-common';
import { AddressDto } from 'webcommon/shared';

@Component({
  selector: 'ap-address',
  styleUrls: [ './ap-address.component.less' ],
  templateUrl: './ap-address.component.html',
})
export class ApAddressComponent {
  static readonly ajsComponentName = 'apAddress';

  @Input() address: AddressDto;

  constructor(
    private readonly bridgeService: BridgeService,
    private readonly browserService: BrowserService,
    private readonly deviceSettingsRepository: DeviceSettingsRepository,
  ) {

  }

  openMap(event: Event) {
    event.stopPropagation();

    if (this.deviceSettingsRepository.isPrm || this.deviceSettingsRepository.isStandaloneBrowser) {
      // eslint-disable-next-line max-len
      const url = `https://maps.google.com/maps?q=${this.address.Address1}  ${this.address.City}, ${this.address.State} ${this.address.Zip}`;
      this.browserService.getWindow().open(url, '_blank');
    } else {
      this.bridgeService.fireEvent('openExternalMapsApp', {
        Address1: this.address.Address1,
        Address2: this.address.Address2,
        City: this.address.City,
        State: this.address.State,
        Zip: this.address.Zip,
        Country: this.address.Country
      });
      // fire event or whatever is needed to open the external map app with the address
    }
  }
}
